export const MERMAID_CDN_URL =
  'https://cdn.jsdelivr.net/npm/mermaid@11/dist/mermaid.min.js';

export const MERMAID_RESET_STYLES = `
  /* Reset mermaid styles */
  #mermaid {
    fill: none;
    margin: 0 auto;
    display: block;
  }
  #mermaid .node rect {
    fill: var(--mm-color-mindmap);
    stroke: currentColor;
    color: var(--mm-color-mindmap-foreground)
  }

  #mermaid .node polygon {
    fill: var(--mm-color-muted);
    stroke: currentColor;
    color: var(--mm-color-muted-foreground)
  }

  #mermaid span {
    fill: currentColor;
    color: var(--mm-color-mindmap-foreground)
  }
`;
